// extracted by mini-css-extract-plugin
module.exports = {"form":"styles-module__form___3hC1t","input":"styles-module__input___28bDf","btn":"styles-module__btn___I-OkD","icon":"styles-module__icon___3FuAD"};